"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "porlezza": {
    "019110a4": [{
      "hkey": "a6055210",
      "slug": "porlezza",
      "name": "Porlezza",
      "primary": true,
      "skipSearch": false
    }],
    "agria": [{
      "hkey": "a6055210",
      "slug": "porlezza",
      "name": "Porlezza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eaf28031": [{
      "hkey": "e080c8b7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "begna": [{
      "hkey": "e080c8b7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "porlezza"
    }],
    "a101c92b": [{
      "hkey": "e080c8b7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "tavordo": [{
      "hkey": "e080c8b7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "porlezza"
    }]
  }
};
exports["default"] = _default;